var map = {
	"./_fallbackIcon.svg": 569,
	"./add-card-hover.svg": 570,
	"./add-card.svg": 571,
	"./add-photo.svg": 572,
	"./an-home-building.svg": 573,
	"./an-interaction.svg": 574,
	"./an-people-group.svg": 575,
	"./an-people-peer.svg": 576,
	"./an-school-building.svg": 577,
	"./an-teacher-instruct.svg": 578,
	"./an-teachers-feedback.svg": 579,
	"./an_laptop.svg": 580,
	"./angle-double-left.svg": 581,
	"./angle-double-right.svg": 582,
	"./angle-down.svg": 583,
	"./angle-up.svg": 584,
	"./apps.svg": 585,
	"./archive.svg": 586,
	"./arrow-alt.svg": 587,
	"./arrow-angle-collapse.svg": 588,
	"./arrow-angle-down.svg": 589,
	"./arrow-angle-expand.svg": 590,
	"./arrow-angle-left.svg": 591,
	"./arrow-angle-right.svg": 592,
	"./arrow-angle-up-down.svg": 593,
	"./arrow-angle-up.svg": 594,
	"./arrow-backward.svg": 595,
	"./arrow-carvet-down.svg": 596,
	"./arrow-carvet-left.svg": 597,
	"./arrow-carvet-right.svg": 598,
	"./arrow-carvet-up-down-ascending.svg": 599,
	"./arrow-carvet-up-down-descending.svg": 600,
	"./arrow-carvet-up-down-inactive.svg": 601,
	"./arrow-carvet-up-down.svg": 602,
	"./arrow-carvet-up.svg": 603,
	"./arrow-diangonal-right.svg": 604,
	"./arrow-down.svg": 605,
	"./arrow-enter.svg": 606,
	"./arrow-external-link.svg": 607,
	"./arrow-forward.svg": 608,
	"./arrow-inward.svg": 609,
	"./arrow-left.svg": 610,
	"./arrow-outward.svg": 611,
	"./arrow-right-left.svg": 612,
	"./arrow-right.svg": 613,
	"./arrow-sync.svg": 614,
	"./arrow-up-down.svg": 615,
	"./arrow-up.svg": 616,
	"./assignment-material.svg": 617,
	"./assignment-question.svg": 618,
	"./assignment.svg": 619,
	"./attachment.svg": 620,
	"./backpack.svg": 621,
	"./bell-gradient-dark.svg": 622,
	"./bell-gradient-light.svg": 623,
	"./bell-gradient.svg": 624,
	"./bell.svg": 625,
	"./bomb.svg": 626,
	"./book-open.svg": 627,
	"./book.svg": 628,
	"./bookmark.svg": 629,
	"./books-stack.svg": 630,
	"./bubble- box-speech.svg": 631,
	"./bubble-blank.svg": 632,
	"./bubble-box-speech.svg": 633,
	"./bubble-speech.svg": 634,
	"./calendar.svg": 635,
	"./camera.svg": 636,
	"./caret-down.svg": 637,
	"./caret-right.svg": 638,
	"./chain.svg": 639,
	"./check-sm.svg": 640,
	"./check.svg": 641,
	"./checkerboard.svg": 642,
	"./checklist-gradient-white.svg": 643,
	"./checklist-gradient.svg": 644,
	"./checklist.svg": 645,
	"./chevron-down.svg": 646,
	"./chevron-left.svg": 647,
	"./chevron-right.svg": 648,
	"./circle-arrow-left.svg": 649,
	"./circle-arrow-right.svg": 650,
	"./circle-blackboard-gray.svg": 651,
	"./circle-blackboard-green.svg": 652,
	"./circle-blackboard.svg": 653,
	"./circle-book.svg": 654,
	"./circle-check-fill.svg": 655,
	"./circle-checklist.svg": 656,
	"./circle-checkmark.svg": 657,
	"./circle-cross.svg": 658,
	"./circle-empty.svg": 659,
	"./circle-exclamation-orange.svg": 660,
	"./circle-exclamation-red.svg": 661,
	"./circle-exclamation.svg": 662,
	"./circle-google-drive-logo.svg": 663,
	"./circle-graduate-cap-gray.svg": 664,
	"./circle-graduate-cap.svg": 665,
	"./circle-information.svg": 666,
	"./circle-labels-gray.svg": 667,
	"./circle-labels.svg": 668,
	"./circle-minus.svg": 669,
	"./circle-misc.svg": 670,
	"./circle-people-gray.svg": 671,
	"./circle-people.svg": 672,
	"./circle-person-gray.svg": 673,
	"./circle-person.svg": 674,
	"./circle-plus.svg": 675,
	"./circle-profile-gray-exclamation.svg": 676,
	"./circle-profile-gray.svg": 677,
	"./circle-question.svg": 678,
	"./circle-stack.svg": 679,
	"./circle-stacked-checkmark-gray.svg": 680,
	"./circle-stacked-checkmark.svg": 681,
	"./circle-stacked-ribbon-filled-gray.svg": 682,
	"./circle-stacked-ribbon-filled.svg": 683,
	"./circle-stacked-ribbon-gray.svg": 684,
	"./circle-stacked-ribbon.svg": 685,
	"./circle-star-gray.svg": 686,
	"./circle-star.svg": 687,
	"./circle-zipped-file-gray.svg": 688,
	"./circle-zipped-file.svg": 689,
	"./classes.svg": 690,
	"./clipboard.svg": 691,
	"./clock-history.svg": 692,
	"./clock.svg": 693,
	"./close.svg": 694,
	"./code.svg": 695,
	"./coding.svg": 696,
	"./cog-fill-gradient-white.svg": 697,
	"./cog-fill.svg": 698,
	"./cog.svg": 699,
	"./cogs.svg": 700,
	"./collection.svg": 701,
	"./comment-o.svg": 702,
	"./connection-no.svg": 703,
	"./copy-link.svg": 704,
	"./copy.svg": 705,
	"./create-drive.svg": 706,
	"./cross-sm.svg": 707,
	"./cross.svg": 708,
	"./cube.svg": 709,
	"./delete.svg": 710,
	"./description.svg": 711,
	"./diamond.svg": 712,
	"./dots.svg": 713,
	"./drive-coloured.svg": 714,
	"./drive.svg": 715,
	"./dropdown-button.svg": 716,
	"./duplicate.svg": 717,
	"./edit-cog.svg": 718,
	"./edit.svg": 719,
	"./editor.svg": 720,
	"./edublogs-icon.svg": 721,
	"./ellipsis-h.svg": 722,
	"./ellipsis.svg": 723,
	"./emoji-books-stack.svg": 724,
	"./emoji-books.svg": 725,
	"./emoji-nerdface.svg": 726,
	"./emoji-open-book.svg": 727,
	"./emoji-partypopper.svg": 728,
	"./emoji-pen.svg": 729,
	"./emoji-raisinghands.svg": 730,
	"./emoji-school-bag.svg": 731,
	"./emoji-sparkles.svg": 732,
	"./emoji-teacher.svg": 733,
	"./emoji-telescope.svg": 734,
	"./emoji-victoryhand.svg": 735,
	"./emoji-writinghand.svg": 736,
	"./envelope-o.svg": 737,
	"./envelope.svg": 738,
	"./exclamation-circle.svg": 739,
	"./exclamation-triangle.svg": 740,
	"./exclamation.svg": 741,
	"./expand.svg": 742,
	"./eye-closed.svg": 743,
	"./eye.svg": 744,
	"./file-add.svg": 745,
	"./file-copy.svg": 746,
	"./file-download-cloud.svg": 747,
	"./file-download.svg": 748,
	"./file-upload-cloud.svg": 749,
	"./file-upload.svg": 750,
	"./file.svg": 751,
	"./fill-circle-exclamation.svg": 752,
	"./fill-circle-question.svg": 753,
	"./fill-envelope.svg": 754,
	"./fill-focused-browsing.svg": 755,
	"./filter-funnel.svg": 756,
	"./filter-lines.svg": 757,
	"./filter.svg": 758,
	"./fire.svg": 759,
	"./flag-fill.svg": 760,
	"./flag.svg": 761,
	"./focus-shield.svg": 762,
	"./focus.svg": 763,
	"./focused-browsing-on.svg": 764,
	"./folder.svg": 765,
	"./frown-o.svg": 766,
	"./globe.svg": 767,
	"./google-classroom-round.svg": 768,
	"./google-classroom-square.svg": 769,
	"./google-classroom.svg": 770,
	"./google-data-studio.svg": 771,
	"./google-document.svg": 772,
	"./google-drawing.svg": 773,
	"./google-drive.svg": 774,
	"./google-folder.svg": 775,
	"./google-form.svg": 776,
	"./google-gmail.svg": 777,
	"./google-image.svg": 778,
	"./google-jam.svg": 779,
	"./google-logo-drive.svg": 780,
	"./google-map.svg": 781,
	"./google-pdf.svg": 782,
	"./google-plus.svg": 783,
	"./google-presentation.svg": 784,
	"./google-sheet.svg": 785,
	"./google-site.svg": 786,
	"./google-slides.svg": 787,
	"./google-spreadsheet.svg": 788,
	"./group.svg": 789,
	"./hamburger.svg": 790,
	"./hand-holding-pen.svg": 791,
	"./heart.svg": 792,
	"./home.svg": 793,
	"./icon-filter.svg": 794,
	"./icon-flag-australia.svg": 795,
	"./icon-flag-canada.svg": 796,
	"./icon-flag-new-zealand.svg": 797,
	"./icon-flag-usa.svg": 798,
	"./icon_card.svg": 799,
	"./icon_group.svg": 800,
	"./icon_workspace.svg": 801,
	"./label-filled.svg": 802,
	"./label.svg": 803,
	"./lightbulb-o.svg": 804,
	"./link.svg": 805,
	"./list-arrow-animated.svg": 806,
	"./list-arrow.svg": 807,
	"./list-checkmark.svg": 808,
	"./loader-light.svg": 809,
	"./loader.svg": 810,
	"./lock-fill.svg": 811,
	"./lock.svg": 812,
	"./login-logo-google.svg": 813,
	"./logo-hapara-small-black.svg": 814,
	"./logo-hapara-small-light.svg": 815,
	"./logo-hapara-small.svg": 816,
	"./magnifying-glass-plus.svg": 817,
	"./mail-reply.svg": 818,
	"./map-pin.svg": 819,
	"./material-icon-folder.svg": 820,
	"./members-gradient-white.svg": 821,
	"./members-gradient.svg": 822,
	"./message-text-fill.svg": 823,
	"./message-text.svg": 824,
	"./minus-sm.svg": 825,
	"./minus.svg": 826,
	"./modal-close.svg": 827,
	"./modules.svg": 828,
	"./multiple-devices.svg": 829,
	"./multiple-logins.svg": 830,
	"./open-book.svg": 831,
	"./paperdoll-fill-partial.svg": 832,
	"./paperdoll-fill.svg": 833,
	"./paperdoll-outline.svg": 834,
	"./pencil-alt.svg": 835,
	"./pencil-fill.svg": 836,
	"./pencil.svg": 837,
	"./plus-circle.svg": 838,
	"./plus-sm.svg": 839,
	"./plus-thick.svg": 840,
	"./plus.svg": 841,
	"./power-off.svg": 842,
	"./printer.svg": 843,
	"./profile-group-filled.svg": 844,
	"./profile-group-gradient-white.svg": 845,
	"./profile-group-gradient.svg": 846,
	"./profile-group.svg": 847,
	"./profile-solo.svg": 848,
	"./pushpin.svg": 849,
	"./question-circle-o.svg": 850,
	"./question.svg": 851,
	"./record.svg": 852,
	"./recording.svg": 853,
	"./refresh.svg": 854,
	"./remove.svg": 855,
	"./return-final.svg": 856,
	"./return-for-edit.svg": 857,
	"./rocket.svg": 858,
	"./school-bag.svg": 859,
	"./screen-pause.svg": 860,
	"./sd-arrow-angle-left-white.svg": 861,
	"./sd-arrow-angle-left.svg": 862,
	"./sd-arrow-angle-right-white.svg": 863,
	"./sd-arrow-angle-right.svg": 864,
	"./sd-arrow-carvet-down.svg": 865,
	"./sd-arrow-carvet-up.svg": 866,
	"./sd-calendar-outline.svg": 867,
	"./sd-cross.svg": 868,
	"./sd-filterAll.svg": 869,
	"./sd-folder-fill-white.svg": 870,
	"./sd-folder-fill.svg": 871,
	"./sd-folder-outline.svg": 872,
	"./sd-graphic-notebook.svg": 873,
	"./sd-layout-arrow.svg": 874,
	"./sd-speech-box-fill-white.svg": 875,
	"./sd-speech-box-fill.svg": 876,
	"./sd-speech-box-outline.svg": 877,
	"./sd-workbook-fill-white.svg": 878,
	"./sd-workbook-fill.svg": 879,
	"./sd-workbook-outline.svg": 880,
	"./search.svg": 881,
	"./share.svg": 882,
	"./sharing.svg": 883,
	"./single-device.svg": 884,
	"./sitemap.svg": 885,
	"./smiley-face.svg": 886,
	"./sort-asc.svg": 887,
	"./sort-desc.svg": 888,
	"./spinner.svg": 889,
	"./stack.svg": 890,
	"./star-fill.svg": 891,
	"./star.svg": 892,
	"./startable.svg": 893,
	"./started.svg": 894,
	"./student-group-add.svg": 895,
	"./student-group-confirm-delete-alert.svg": 896,
	"./student-groups-collapse.svg": 897,
	"./student-groups-expand.svg": 898,
	"./student-selector-added-teacher-alert.svg": 899,
	"./student-selector-search-clear.svg": 900,
	"./student-selector-search.svg": 901,
	"./submitted.svg": 902,
	"./tag.svg": 903,
	"./teacher.svg": 904,
	"./trash-o.svg": 905,
	"./trash.svg": 906,
	"./twitter.svg": 907,
	"./unlock.svg": 908,
	"./unshare.svg": 909,
	"./upload.svg": 910,
	"./video-play.svg": 911,
	"./workspace-icon-gradient-white.svg": 912,
	"./workspace-icon-gradient.svg": 913,
	"./workspace-icon.svg": 914,
	"./ws-thumbnail-default-square.svg": 915,
	"./youtube.svg": 916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 568;